/**
 * 正式参考对象创建来源枚举。
 *
 * 说明：
 * 1. 该枚举只用于正式基准轴 / 基准面 / 基准点对象；
 * 2. 用于区分对象是系统默认内置、零件特征态创建，还是装配体态创建；
 * 3. 禁止回退到 `userData` 或字符串魔法值，统一收口到显式枚举。
 */
export enum ReferenceCreationContext {
  /** 系统默认内置对象。 */
  DefaultBuiltIn = 'default-built-in',
  /** 零件特征态下创建。 */
  PartFeature = 'part-feature',
  /** 装配体态下创建。 */
  Assembly = 'assembly',
}
